<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <!-- <div style="text-align: left" class="p-3 mb-2">
        <h4>
          Request Received
          <b-button variant="danger" @click="handleBack">
                    <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
                </b-button>
        </h4>
        <hr />
      </div> -->
      <div class="col-12" style="margin-top:4px;">
    <h5> Request Received:
     <b-btn
          class="btn-danger float-right"
           style="text-align: right;"
          @click="handleBack()"
        >
         <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
        </b-btn></h5>
      </div>
      <hr>
      <p> Request received for Transport Certificate</p>
      <div class="panel-body">
        <div>
          <div class="md-4">
            <b-card >
            <b-card-text class="mycard" @click="viewHandle1">
              <table style="">
                <tr>
                  <td  style="text-align: left">Vehicle No</td>
                  <td style="text-align: left">:</td>
                  <td style="text-align: left">MH04-BQ-3443</td>
                  <td>
                    <b-badge variant="light"><b-icon-check-circle style="color:green;font-size:25px;"></b-icon-check-circle></b-badge>
                  </td>
                  <!-- <td>
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                    </b-dropdown>
                  </td> -->
                </tr>
                <tr>
                  <td width="45%" style="text-align: left">Driver Name</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Satish S Patil</td>
                  
                </tr>

                <tr>
                  <td width="45%" style="text-align: left">Transport From</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Kolhapur</td>
                </tr>
                <tr>
                  <td width="45%" style="text-align: left">Transport To</td>
                  <td width="1%" style="text-align: left">:</td>
                  <td width="54%" style="text-align: left">Sangli</td>
                </tr>
              </table>
            </b-card-text>
            </b-card>
          </div><br/>
              <div class="col-md-12">
            <center>
                <b-button variant="success" @click="handleCertificate">Request For Transport Certificate</b-button>
            </center>
        </div>
         
<br/>
         

          <!-- <b-button
              type="button"
              size="sm"
              variant="primary"
              style="float: right"
              >
            
            <router-link
                        style="color:white;"
                        :to="{ name: 'medical'}"
                      >View</router-link>
            
             </b-button> -->
             <br/>
          
          
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    viewHandle1(){
      this.$router.push('/home/transport_certificate');
    },
    viewHandle(){
      this.$router.push('/home/req_certificate');
    },
    
     handleBack(){
            this.$router.go(-1);
        },
    handleCertificate() {
      this.$router.push('/transportcertificate');
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
body {
  line-height: 1;
}
</style>
